import { Box } from "@mui/material";
import MenuSection from "./../components/MenuSection"; 
import Food from "./../components/Food"; 

const Menu = () => {
  return (
    <Box>
      {/* Video Background with Centered Menu Heading */}
      <MenuSection /> 
      
      {/* <Food /> */}
    </Box>
  );
};

export default Menu;
